const $ = window.$
import React from 'react'
import {createRoot} from "react-dom/client"
import {connect, Provider} from 'react-redux'
import {BarCharts} from './aggregates'
import './reducers'
import {fetchReviews} from './http'
import {PaginatorNav} from 'js/studios/shared/pagination'
import {StarRating, PartialStarRating} from 'js/studios/shared/star_rating'
import {ExpandMoreIcon} from 'js/studios/shared/svg_icons'
import {FormattedText} from 'js/studios/shared/utils'
import moment from 'moment'
import {scrollToElement} from 'js/studios/shared/animation'
import {trackEventSP} from 'js/studios/shared/tracking'

class ReviewHeaders extends React.Component {

  render(){
    let displayCount = this.props.aggregateRatings.count.toLocaleString('en-US')
    return (
      <section className="reviews_header">
        <div className="reviews_header_section counts">
          <div className="aggregate_counts">
            <h3>All Reviews</h3>
            <div className="reviews_aggregate_container">
              <div className="aggregate_display">
                <PartialStarRating rating={this.props.aggregateRatings.aggregateRating} />
                <h5>{this.props.aggregateRatings.aggregateRating}/5</h5>
                <h5>{displayCount} Reviews</h5>
              </div>
            </div>
            <BarCharts ratings={this.props.aggregateRatings.breakdown} totalCount={this.props.aggregateRatings.count}/>
          </div>
        </div>
        <div className="reviews_header_section disclaimer">
          <h3>Our Review Policy</h3>
          <p>Each of our reviews is from a customer who purchased one of our custom designed pieces of jewelry. We never alter reviews, and offer no incentives for submitting a review of your experience.</p>
        </div>
      </section>
    )
  }
}


@connect(state => ({'filters': state.reviewPage.filters}))
class Filters extends React.Component {

  updateRating(e){
    this.props.dispatch({
      type: 'REVIEWS_FILTER_RATING',
      rating: $(e.target).val()
    })
    trackEventSP('input_reviews_filter', 'browse',{
      'filter': 'rating',
      'value_entered': $(e.target).val()
    })
    fetchReviews()
  }

  updateCategory(e){
    this.props.dispatch({
      type: 'REVIEWS_FILTER_CATEGORY',
      category: $(e.target).val()
    })
    trackEventSP('input_reviews_filter', 'browse',{
      'filter': 'category',
      'value_entered': $(e.target).val()
    })
    fetchReviews()
  }

  render(){
    return (
      <section id="reviews_filters" className="review_filters">
        <div className="reviews-filters-inner">
          <h4 className="filters_header">Filter</h4>
          <div className="review-filters-inputs">
            <div className="input-group">
              <label htmlFor="rating">By Rating</label>
              <select className="form-input" name="rating" value={this.props.filters.rating || ''} onChange={this.updateRating.bind(this)}>
                <option value="">All</option>
                <option value="5">5 Star</option>
                <option value="4">4 Star</option>
                <option value="3">3 Star</option>
                <option value="2">2 Star</option>
                <option value="1">1 Star</option>
              </select>
            </div>
            <div className="input-group">
              <label htmlFor="category">By Category</label>
              <select className="form-input" name="category" value={this.props.filters.category || ''}  onChange={this.updateCategory.bind(this)}>
                <option value="">All</option>
                <option value="engagement">Engagement Rings</option>
                <option value="pendants">Pendants / Necklaces</option>
                <option value="statement">Statement Rings</option>
                <option value="signet">Signet Rings</option>
                <option value="class">Class Rings</option>
                <option value="bands">Wedding Rings / Bands</option>
                <option value="cufflinks">Cufflinks</option>
                <option value="bracelet">Bracelets</option>
                <option value="earrings">Earrings</option>
                <option value="lapelpin">Lapel Pins</option>
              </select>
            </div>
          </div>
        </div>
      </section>
    )
  }

}


class Review extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      'expanded': false
    }
  }

  toggleLength(e){
    e.preventDefault()
    this.setState({'expanded': this.state.expanded !== true})
  }

  render(){
    let review = this.props.review
    let reviewDate = moment.unix(review.createdAt)
    let placeholderImage = "//images.custommade.com/kyMNqSTksuM1x7j8WbtGWD6ZOHw=/115x115/custommade-photosets/0/0.4384.jpg"
    let photosHTML = []

    if (review.showFinalPhotos){
      photosHTML = review.finalPhotos.map((photo, index) => (
        <img key={photo.id} loading="lazy" className="attachment" src={photo.smallUrl} alt={review.projectName + " " + (index + 1)} data-fancybox data-fancybox-href={photo.fullUrl} />
      ))
    }

    return (
      <div className="review_item">
        <div className="review_info">
          {review.customerPhoto !== placeholderImage ? <div className="customer_avatar"><img src={review.customerPhoto} alt={review.customerName + "'s avatar"}/></div> : ''}
          <div className="project_info">
            <div className="customer_name">
              <h4>{review.customerName}</h4>
            </div>
            <StarRating rating={review.rating} />
            <div className="review_category">
              <h5>{review.projectName}</h5>
            </div>
            <div className="review_date">
              <p>{reviewDate.format("M/D/YY")}</p>
            </div>
          </div>
        </div>

        <div className={this.state.expanded ? "review_contents expanded" : "review_contents"}>

          <ul className="review_photos flex-box-attachments">
            {photosHTML}
          </ul>
          <div className="overflow_gradient"></div>
          <div className="review_details">
            <FormattedText>{review.comment}</FormattedText>
            <div className="review_breakdown">
              <div className="breakdown_item">
                <h5>Timeliness</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.timelinessScore} />
                </div>
              </div>
              <div className="breakdown_item">
                <h5>Quality</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.qualityScore} />
                </div>
              </div>
              <div className="breakdown_item">
                <h5>Communication</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.communicationScore} />
                </div>
              </div>
              <div className="breakdown_item">
                <h5>Shipping/Delivery</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.shippingScore} />
                </div>
              </div>
              <div className="breakdown_item">
                <h5>Professionalism</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.professionalismScore} />
                </div>
              </div>
              <div className="breakdown_item">
                <h5>Value</h5>
                <div className="breakdown_stars">
                  <StarRating rating={review.valueScore} />
                </div>
              </div>
            </div>
          </div>
          <a className="review_contents_toggle" onClick={this.toggleLength.bind(this)} >Continue Reading <span><ExpandMoreIcon width="15" height="15" /></span></a>
        </div>
      </div>
    )
  }
}

@connect(state => ({reviews: state.reviewPage.reviews, page: state.reviewPage.page}))
class Reviews extends React.Component {
  render(){
    let reviews = this.props.reviews.map(function(review){
      return <Review key={review.id} review={review} />
    })
    return (
      <section className="reviews_list">
        {reviews}
      </section>
    )
  }

}


@connect(state => ({page: state.reviewPage.page, numOfPages: state.reviewPage.numOfPages, filters: state.reviewPage.filters}))
class Pagination extends React.Component {

  updatePage(page){
    this.props.dispatch({
      type: 'REVIEWS_CHANGE_PAGE',
      page: page
    })
    fetchReviews()
    scrollToElement("#reviews_filters")
    window.history.pushState({}, '', this.createPageUrl(page))
  }

  createPageUrl(page){
    const params = new URLSearchParams()

    if (this.props.filters.category) {
      params.set("category", this.props.filters.category)
    }
    if (this.props.filters.rating) {
      params.set("rating", this.props.filters.rating)
    }
    if (page > 1) {
      params.set("page", page)
    }

    return `${window.location.pathname}?${params.toString()}`
  }

  render(){
    return <PaginatorNav currentPage={this.props.page} numOfPages={this.props.numOfPages} onPageChange={this.updatePage.bind(this)} createPageUrl={this.createPageUrl.bind(this)}/>
  }
}


class Main extends React.Component {

  render(){
    return (
      <Provider store={window.cm.store}>
        <div className="reviews-body">
          <ReviewHeaders aggregateRatings={this.props.aggregateRatings} />
          <Filters />
          <Reviews />
          <Pagination />
        </div>
      </Provider>
    )
  }
}

window.$(document).ready(function(){
  $('[data-fancybox]').fancybox({openEffect: 'fade', closeEffect: 'fade'})
  createRoot(document.getElementById('reviews_wrapper')).render(<Main aggregateRatings={window.cm.aggregateRatings} />)
})
